// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.custom-theme_modal-content_yCbnm {
  max-width: 750px;
}

.custom-theme_body__ajZr {
  background: var(--ui-modal-background);
  padding: 1.5rem 2.25rem;
  min-height: 200px;
  max-height: calc(100vh - 250px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.custom-theme_content_pDbz9 {
  flex-grow: 1;
}

.custom-theme_title-box_CGwiu {
  top: 20px;
  margin: 20px;
  display: flex;
  justify-content: space-between;
}

.custom-theme_apply_Zh6TK {
  margin-top: auto;
  display: flex;
  justify-content: flex-end;
}

.custom-theme_title_HQH53 {
  font-size: large;
  font-weight: bold;
}

.custom-theme_color-input_uryAF {
  border: none;
}

/* For small screens, such as in the embed */

@media (max-height: 600px) {
  .custom-theme_modal-content_yCbnm {
    margin: 50px auto;
  }
  .custom-theme_body__ajZr {
    max-height: calc(100vh - 150px);
  }
}

.custom-theme_setting_YZDNU {
  display: flex;
  flex-direction: column;
  padding: 0.5rem 1rem;
  margin: 0.25rem 0;
  border-radius: 4px;
}

.custom-theme_setting_YZDNU.custom-theme_active_VQDCD {
  background: var(--badge-background);
}

.custom-theme_setting_YZDNU:hover,
.custom-theme_setting_YZDNU:focus-within {
  background: var(--badge-border);
}

.custom-theme_label_crzsc {
  height: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.custom-theme_setting_YZDNU table {
  border-collapse: collapse;
}

.custom-theme_setting_YZDNU tr,
.custom-theme_setting_YZDNU td,
.custom-theme_setting_YZDNU th {
  padding: 0;
  margin: 0;
  border: 1px solid var(--ui-tertiary);
}

.custom-theme_checkbox_CVXkj {
  margin-right: 0.5rem;
}

.custom-theme_info_LxUaS {
  margin-bottom: 0.25rem;
}

.custom-theme_header_N76Z3 {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0.5rem 0 0 0;
  font-weight: bold;
}

.custom-theme_divider_NTkQu {
  flex-grow: 1;
  margin-left: 1rem;
  border-top: 1px dashed var(--ui-tertiary);
}

.custom-theme_button_Dp4ib {
  font-family: inherit;
  font-size: 14px;
  background-color: var(--looks-secondary);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  margin: 0;
  border-radius: 4px;
  cursor: pointer;
  font-family: inherit;
  font-weight: bold;
}

.custom-theme_button_Dp4ib:active,
.custom-theme_button_Dp4ib:focus-within {
  box-shadow: 0 0 0 3px var(--looks-transparent);
}

.custom-theme_warning_t7oUO {
  padding: 0.5rem 1rem;
  margin: 0.25rem 0;
  border-radius: 4px;
  background: rgb(233, 233, 53);
  color: var(--text-primary-default);
}
`, "",{"version":3,"sources":["webpack://./src/components/ae-custom-theme/custom-theme.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA,4CAA4C;;AAE5C;EACE;IACE,iBAAiB;EACnB;EACA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,UAAU;EACV,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,wCAAwC;EACxC,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;AACpC","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.modal-content {\n  max-width: 750px;\n}\n\n.body {\n  background: var(--ui-modal-background);\n  padding: 1.5rem 2.25rem;\n  min-height: 200px;\n  max-height: calc(100vh - 250px);\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.content {\n  flex-grow: 1;\n}\n\n.title-box {\n  top: 20px;\n  margin: 20px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.apply {\n  margin-top: auto;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.title {\n  font-size: large;\n  font-weight: bold;\n}\n\n.color-input {\n  border: none;\n}\n\n/* For small screens, such as in the embed */\n\n@media (max-height: 600px) {\n  .modal-content {\n    margin: 50px auto;\n  }\n  .body {\n    max-height: calc(100vh - 150px);\n  }\n}\n\n.setting {\n  display: flex;\n  flex-direction: column;\n  padding: 0.5rem 1rem;\n  margin: 0.25rem 0;\n  border-radius: 4px;\n}\n\n.setting.active {\n  background: var(--badge-background);\n}\n\n.setting:hover,\n.setting:focus-within {\n  background: var(--badge-border);\n}\n\n.label {\n  height: 32px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.setting table {\n  border-collapse: collapse;\n}\n\n.setting tr,\n.setting td,\n.setting th {\n  padding: 0;\n  margin: 0;\n  border: 1px solid var(--ui-tertiary);\n}\n\n.checkbox {\n  margin-right: 0.5rem;\n}\n\n.info {\n  margin-bottom: 0.25rem;\n}\n\n.header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin: 0.5rem 0 0 0;\n  font-weight: bold;\n}\n\n.divider {\n  flex-grow: 1;\n  margin-left: 1rem;\n  border-top: 1px dashed var(--ui-tertiary);\n}\n\n.button {\n  font-family: inherit;\n  font-size: 14px;\n  background-color: var(--looks-secondary);\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  margin: 0;\n  border-radius: 4px;\n  cursor: pointer;\n  font-family: inherit;\n  font-weight: bold;\n}\n\n.button:active,\n.button:focus-within {\n  box-shadow: 0 0 0 3px var(--looks-transparent);\n}\n\n.warning {\n  padding: 0.5rem 1rem;\n  margin: 0.25rem 0;\n  border-radius: 4px;\n  background: rgb(233, 233, 53);\n  color: var(--text-primary-default);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-content": `custom-theme_modal-content_yCbnm`,
	"modalContent": `custom-theme_modal-content_yCbnm`,
	"body": `custom-theme_body__ajZr`,
	"content": `custom-theme_content_pDbz9`,
	"title-box": `custom-theme_title-box_CGwiu`,
	"titleBox": `custom-theme_title-box_CGwiu`,
	"apply": `custom-theme_apply_Zh6TK`,
	"title": `custom-theme_title_HQH53`,
	"color-input": `custom-theme_color-input_uryAF`,
	"colorInput": `custom-theme_color-input_uryAF`,
	"setting": `custom-theme_setting_YZDNU`,
	"active": `custom-theme_active_VQDCD`,
	"label": `custom-theme_label_crzsc`,
	"checkbox": `custom-theme_checkbox_CVXkj`,
	"info": `custom-theme_info_LxUaS`,
	"header": `custom-theme_header_N76Z3`,
	"divider": `custom-theme_divider_NTkQu`,
	"button": `custom-theme_button_Dp4ib`,
	"warning": `custom-theme_warning_t7oUO`
};
export default ___CSS_LOADER_EXPORT___;
